<mat-form-field fxFlex="100" class="second-input-style">
  <mat-label>{{ matLabel }}</mat-label>

  <!-- Spinner -->
  <mat-spinner
    class="spinner-prefix-padding"
    matPrefix
    color="accent"
    [diameter]="30"
    *ngIf="spinnerLoading"
  >
  </mat-spinner>

  <!-- Mat Select -->
  <mat-select
    [formControl]="control"
    [multiple]="multiSelect"
    [disabled]="isDisabled"
    (selectionChange)="onSelectionChange($event)"
  >
    <!-- Search -->
    <mat-option>
      <ngx-mat-select-search
        noEntriesFoundLabel="No matching result found"
        placeholderLabel="Search..."
        #searchBox
      >
      </ngx-mat-select-search>
    </mat-option>

    <!-- Select All -->
    <mat-checkbox
      *ngIf="optionAll"
      color="primary"
      class="mat-option"
      (click)="$event.stopPropagation()"
      (change)="toggleAll.emit($event.checked)"
    >
      All
    </mat-checkbox>

    <!-- Options -->
    <mat-option
      *ngFor="
        let item of options | selectSearch : searchBox.value : searchCriteria
      "
      [value]="toUpperCase 
             ? (typeof item[valueKey] === 'string' 
                  ? item[valueKey].toUpperCase() 
                  : item[valueKey]) 
             : item[valueKey]"
    >
      {{ toUpperCase ? item[displayKey].toUpperCase() : item[displayKey] }}
    </mat-option>
  </mat-select>
</mat-form-field>
